// TODO - StyledComponents `theme` provide could negate the necessity of extracting the likes of bgColor from bgProps?
// -- (and instead have it directly available in the build in `theme` styled component function param?

import React from 'react';
import * as S from './BackgroundContainer.style';

import { BackgroundContainerProps } from './BackgroundContainer.types';

export * from './BackgroundContainer.types';

export interface IProps extends BackgroundContainerProps {
	isDefaultModule?: boolean;
	children?: React.ReactNode;
	allowChildrenEscape?: boolean;
}

const BackgroundContainer = ({
	children,
	bgImageInline,
	bgImageInlineAltText,
	allowChildrenEscape,
	...props
}: IProps) => {
	const { bgImage } = props;

	return (
		<S.Wrapper allowChildrenScape={allowChildrenEscape}>
			{!!bgImage && bgImageInline ? (
				<S.InlineImgShade {...props}>
					<img src={bgImage} alt={bgImageInlineAltText} />
				</S.InlineImgShade>
			) : (
				<S.Background {...props}>{children}</S.Background>
			)}
		</S.Wrapper>
	);
};

BackgroundContainer.defaultProps = {
	bgPadding: '0',
	bgImageShadeColor: null,
	bgImageShadeOpacity: 0.6,
	bgImagePosition: 'center',
};

export default BackgroundContainer;
